import React, { useState } from 'react';

import { IWidget } from '../../types/IWidget';

import ChartWidget from './chartWidget/chartWidget';
import GridWidget from './gridWidget/gridWidget';
import SummaryWidget from './summaryWidget/summaryWidget';
import TreeListWidget from './treeListWidget/treeListWidget';
import MapWidget from './mapWidget/mapWidget';

import './widget.scss';

const Widget: React.FC<IWidget> = ({
                                     widget,
                                     measures,
                                     periods,
                                     notes,
                                     boardId,
                                     id,
                                     staticProperties,
                                     scenarios,
                                     customisation,
                                     widgets,
                                     handleWidgetMove,
                                     handleWidgetChange,
                                     changeNewIndex,
                                     changeOldIndex,
                                     boardSelectedCurrency,
                                     handlePinWidget,
                                     handleUnpinWidget,
                                     selectedPeriod,
                                     selectedObject,
                                   }) => {
  const [expand, setExpand] = useState<boolean>(false);

  const onExpand = (): void => {
    setExpand(true);
  };

  const onCollapse = (): void => {
    setExpand(false);
  };

  const components = {
    chart: ChartWidget,
    grid: GridWidget,
    summary: SummaryWidget,
    treelist: TreeListWidget,
    map: MapWidget,
  };

  const WidgetComponent = components[widget.type];

  if (!widget.visible) {
    return null;
  }
  return (
    <div
      className={`widget-wrap ${expand ? 'expand-widget' : ''}`}
      style={{
        gridColumnEnd: `span ${widget.columnSpan}`,
        gridRowEnd: `span ${widget.rowSpan}`,
        display: `${widget.visible ? 'block' : 'none'}`,
      }}>
      {WidgetComponent && (
        <WidgetComponent
          scenarios={scenarios}
          expand={expand}
          onExpand={onExpand}
          onCollapse={onCollapse}
          setup={widget.setup}
          widget={widget}
          measures={measures}
          periods={periods}
          notes={notes}
          boardId={boardId}
          id={id}
          staticProperties={staticProperties}
          customisation={customisation}
          widgets={widgets}
          handleWidgetChange={handleWidgetChange}
          handlePinWidget={handlePinWidget}
          handleUnpinWidget={handleUnpinWidget}
          handleWidgetMove={handleWidgetMove}
          changeNewIndex={changeNewIndex}
          changeOldIndex={changeOldIndex}
          boardSelectedCurrency={boardSelectedCurrency}
          selectedPeriod={selectedPeriod}
          selectedObject={selectedObject}
        />
      )}
    </div>
  );
};

export default Widget;
